import { enableProdMode } from '@angular/core';
import '@angular/compiler';
import 'zone.js';
import 'hammerjs';
import {UpgradeModule} from '@angular/upgrade/static';
import { AppModule } from './app.module';
import { platformBrowser } from '@angular/platform-browser';
import environment  from './environment/index';
import {analytics} from './analytics';

if (environment.settings.stage === 'production') {
  enableProdMode();
}

analytics.start();

platformBrowser().bootstrapModule(AppModule)
  .catch(err => console.error(err));
